<template>
    <reconciliation-step-template 
        :nextStep="nextStep" 
        :previousStep="previousStep" 
        @next="goToNextStep"
        @previous="$emit('previous')">
        
        <template #content>
   
            <h3>{{ $l10n.__("Crédit - Débit sans type") }}</h3>
            <p class="fs-3">{{ $l10n.__("Définissez maintenant la colonne comportant l'indication de type de transaction.") }}</p>
            
            <div>
                <div class="step-container-table border-black">
                    <table-selectable-columns 
                        :lines="csv"
                        v-model="value.template.type_from_string.columns"
                        :max="1"
                    />
                </div>
                <div>
                    <p class="fs-3 mt-4 mb-2">{{ $l10n.__("Quels sont les caractères pour désigner les crédits?") }}</p>
                    <text-input
                        mode="edit"
                        v-model="value.template.type_from_string.arguments.credit" />
                    <p class="fs-3 mt-4 mb-2">{{ $l10n.__("Quels sont les caractères pour désigner les débits ?") }}</p>
                    <text-input
                        mode="edit"
                        v-model="value.template.type_from_string.arguments.debit" />
                </div>
            </div>
        </template>
    </reconciliation-step-template>
</template>

<script>
    import TableSelectableColumns from 'vcomponents/utilities/TableSelectableColumns.vue'
    import ImportStepsMixins from './ImportStepsMixins'
    import TextInput from 'vcomponents/inputs/TextInput.vue'

    export default {
        mixins: [ImportStepsMixins],
        data(){
            return {
            }
        },
        created(){
            this.checkPreviousSteps()
        },
        methods: {
            goToNextStep(){
                this.checkMinColumns('type_from_string', 1) ? this.$emit('next') : false
            }
        },
        components: {
            TableSelectableColumns,
            TextInput
        }
    }
</script>

<style scoped>

</style>
